    document.addEventListener("DOMContentLoaded", function() {
        var viewButtons = document.querySelectorAll(".gameButtonView");

        viewButtons.forEach(function(button) {
            button.addEventListener("click", function() {
                var gameDescription = button.getAttribute("data-description");
                var gameMainImage = button.getAttribute("data-main-image");
                var gameName = button.getAttribute("data-name");
                var modalDescription = document.getElementById("gameDescription");
                var modalImage = document.getElementById("gameImage");
                var modalTitle = document.getElementById("gameModalLabel");

                modalDescription.textContent = gameDescription;
                modalImage.src = gameMainImage;
                modalTitle.textContent = gameName;
            });
        });
    });
